import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedShareLinkIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.88334 10.7722L15.1167 7.56111M8.88334 13.2278L15.1167 16.4389M3.5 12C3.5 12.7514 3.79851 13.4721 4.32986 14.0035C4.86122 14.5348 5.58189 14.8333 6.33333 14.8333C7.08478 14.8333 7.80545 14.5348 8.3368 14.0035C8.86816 13.4721 9.16667 12.7514 9.16667 12C9.16667 11.2486 8.86816 10.5279 8.3368 9.99653C7.80545 9.46518 7.08478 9.16667 6.33333 9.16667C5.58189 9.16667 4.86122 9.46518 4.32986 9.99653C3.79851 10.5279 3.5 11.2486 3.5 12ZM14.8333 6.33333C14.8333 7.08478 15.1318 7.80545 15.6632 8.3368C16.1945 8.86816 16.9152 9.16667 17.6667 9.16667C18.4181 9.16667 19.1388 8.86816 19.6701 8.3368C20.2015 7.80545 20.5 7.08478 20.5 6.33333C20.5 5.58189 20.2015 4.86122 19.6701 4.32986C19.1388 3.79851 18.4181 3.5 17.6667 3.5C16.9152 3.5 16.1945 3.79851 15.6632 4.32986C15.1318 4.86122 14.8333 5.58189 14.8333 6.33333ZM14.8333 17.6667C14.8333 18.4181 15.1318 19.1388 15.6632 19.6701C16.1945 20.2015 16.9152 20.5 17.6667 20.5C18.4181 20.5 19.1388 20.2015 19.6701 19.6701C20.2015 19.1388 20.5 18.4181 20.5 17.6667C20.5 16.9152 20.2015 16.1945 19.6701 15.6632C19.1388 15.1318 18.4181 14.8333 17.6667 14.8333C16.9152 14.8333 16.1945 15.1318 15.6632 15.6632C15.1318 16.1945 14.8333 16.9152 14.8333 17.6667Z",
		stroke: "#333333",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedShareLinkIcon);
const Memo = memo(ForwardRef);
export default Memo;
